import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react/index.js'
import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomImage, {LOADING} from '@s-ui/react-atom-image'
import {useSuiContext} from '@s-ui/react-context'

import ExperimentProducts from './experimentProducts.js'

const BASE_CLASS = 'mt-CheckoutResponseContent'

const CheckoutResponseContent = ({pageName, product}) => {
  const {domain, i18n, isMotos} = useSuiContext()

  const config = domain.get('config')
  const PAYMENT_AD_PRODUCT_ID = config.get('PAYMENT_AD_PRODUCT_ID')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const {
    CHECKOUT_SUCCESS_PAGE_NAME,
    CHECKOUT_PENDING_PAGE_NAME,
    CHECKOUT_ERROR_PAGE_NAME,
    CHECKOUT_ACTIVATION_ERROR_PAGE_NAME,
    CHECKOUT_REFUND_ERROR_PAGE_NAME,
    CHECKOUT_REQUEST_ERROR_PAGE_NAME,
    CHECKOUT_UNKNOWN_ERROR_PAGE_NAME,
    USER_ADS_PATH_PATTERN
  } = config.get('page')

  const isPaymentAd = product.id === PAYMENT_AD_PRODUCT_ID
  const isRefundErrorPage = pageName === CHECKOUT_REFUND_ERROR_PAGE_NAME

  const buttonHref = isRefundErrorPage ? i18n.t('SUPPORT_PARTICULAR_URL') : USER_ADS_PATH_PATTERN
  const buttonText = isRefundErrorPage ? 'EMPTY_CASE_CHECKOUT_BUTTON_HELP_TEXT' : 'COMMON.GO_TO_MY_ADS'

  const confirmationData = {
    [CHECKOUT_SUCCESS_PAGE_NAME]: {
      text: isPaymentAd ? `VISIBILITY_PRODUCTS.AD_INSERTED_NOTIFICATION` : 'EMPTY_CASE_CHECKOUT_SUCCESS_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_SUCCESS_TITLE',
      imageUrl: 'illustrations/process-completed-success.svg'
    },
    [CHECKOUT_PENDING_PAGE_NAME]: {
      text: 'EMPTY_CASE_CHECKOUT_PENDING_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_PENDING_TITLE',
      imageUrl: 'illustrations/error-state-connection-alt.svg'
    },
    [CHECKOUT_ERROR_PAGE_NAME]: {
      text: 'EMPTY_CASE_CHECKOUT_ERROR_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_ERROR_TITLE',
      imageUrl: 'illustrations/error-state-connection.svg'
    },
    [CHECKOUT_ACTIVATION_ERROR_PAGE_NAME]: {
      text: 'EMPTY_CASE_CHECKOUT_ACTIVATION_ERROR_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_ACTIVATION_ERROR_TITLE',
      imageUrl: 'illustrations/error-state-connection-alt.svg'
    },
    [CHECKOUT_REFUND_ERROR_PAGE_NAME]: {
      text: 'EMPTY_CASE_CHECKOUT_REFUND_ERROR_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_REFUND_ERROR_TITLE',
      imageUrl: 'illustrations/error-state-connection-alt.svg'
    },
    [CHECKOUT_REQUEST_ERROR_PAGE_NAME]: {
      text: 'EMPTY_CASE_CHECKOUT_REQUEST_ERROR_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_REQUEST_ERROR_TITLE',
      imageUrl: 'illustrations/error-state-connection.svg'
    },
    [CHECKOUT_UNKNOWN_ERROR_PAGE_NAME]: {
      text: 'EMPTY_CASE_CHECKOUT_UNKNOWN_ERROR_TEXT',
      title: 'EMPTY_CASE_CHECKOUT_UNKNOWN_ERROR_TITLE',
      imageUrl: 'illustrations/error-state-connection-alt.svg'
    }
  }

  const {text, title, imageUrl} = confirmationData[pageName] || confirmationData[CHECKOUT_REQUEST_ERROR_PAGE_NAME]

  // TO DO: experiment must be rollouted only for non-motos and only for success page
  const hasExperiment = !isMotos && pageName === CHECKOUT_SUCCESS_PAGE_NAME

  return (
    <main className={`${BASE_CLASS}Wrapper`}>
      <div className={BASE_CLASS}>
        <h1 className={`${BASE_CLASS}Title`}>{i18n.t(title)}</h1>
        <AtomImage
          aria-hidden="true"
          className={`${BASE_CLASS}Image`}
          loading={LOADING.LAZY}
          role="presentation"
          src={`${URL_STATICS_IMAGES}${imageUrl}`}
        />
        <p className={`${BASE_CLASS}Text`}>
          {htmlStringToReactElement(
            i18n.t(text, {
              highlightStart: `<span class="${BASE_CLASS}Text--highlight">`,
              highlightEnd: `</span>`,
              product: product.title ?? ''
            })
          )}
        </p>
        <div className={`${BASE_CLASS}Button`}>
          <AtomButton
            design={atomButtonDesigns.SOLID}
            fullWidth
            href={buttonHref}
            link
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.LARGE}
          >
            {i18n.t(buttonText)}
          </AtomButton>
        </div>
      </div>

      {hasExperiment && <ExperimentProducts />}
    </main>
  )
}

CheckoutResponseContent.displayName = 'CheckoutResponseContent'

CheckoutResponseContent.propTypes = {
  pageName: PropTypes.string.isRequired,
  product: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  })
}

export default CheckoutResponseContent
